import type { DossierRow } from '../types/dossier.types';
import { filterItemsBySearchQuery } from './listSearch';

export const getDossierSearchableValues = (dossier: DossierRow): string[] => [
  dossier.numeroDossier,
  dossier.numeroTracking,
  dossier.numeroCommande,
  dossier.clientPrenom,
  dossier.clientNom,
  `${dossier.clientPrenom} ${dossier.clientNom}`.trim(),
];

export const filterDossiersBySearchQuery = (
  dossiers: DossierRow[],
  searchQuery: string,
): DossierRow[] => filterItemsBySearchQuery(dossiers, searchQuery, getDossierSearchableValues);

export const sortDossiersByLastModified = (dossiers: DossierRow[]): DossierRow[] =>
  [...dossiers].sort(
    (left, right) =>
      new Date(right.dateDerniereModif).getTime() - new Date(left.dateDerniereModif).getTime(),
  );
